import React, { useState } from 'react';
import { CheckoutModal } from './components/CheckoutModal';
import { Hero } from './components/Hero';
import { ValueSection } from './components/ValueSection';
import { IdentificationSection } from './components/IdentificationSection';
import { DarkPremiumSection } from './components/DarkPremiumSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { AccordionSection } from './components/AccordionSection';
import { BonusSection } from './components/BonusSection';
import { DifferenceSection } from './components/DifferenceSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FinalOfferSection } from './components/FinalOfferSection';
import { FaqSection } from './components/FaqSection';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);
  const handleOpenCheckout = () => {
    setIsCheckoutOpen(true);
  };
  const handleCloseCheckout = () => {
    setIsCheckoutOpen(false);
  };
  return <div className="min-h-screen bg-white font-sans pb-24 md:pb-0 selection:bg-terracotta/20 selection:text-terracotta" data-id="element-0">
      <Hero onCheckout={handleOpenCheckout} data-id="element-1" />
      <ValueSection data-id="element-2" />
      <IdentificationSection onCheckout={handleOpenCheckout} data-id="element-3" />
      <DarkPremiumSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <AccordionSection data-id="element-6" />
      <BonusSection data-id="element-7" />
      <DifferenceSection data-id="element-8" />
      <SocialProofSection data-id="element-9" />
      <FinalOfferSection onCheckout={handleOpenCheckout} data-id="element-10" />
      <FaqSection data-id="element-11" />
      <Footer data-id="element-12" />

      <StickyCTA onCheckout={handleOpenCheckout} data-id="element-13" />

      <CheckoutModal isOpen={isCheckoutOpen} onClose={handleCloseCheckout} data-id="element-14" />
    </div>;
}